
import './header.scss';
import Logo from '../../components/logo';

const HeaderComponent = () => {
    return (
        <>
            <Logo />
        </>


    );
}

export default HeaderComponent;
